import "../css/DeleteModal.css";
import Modal from "./Modal";

const DeleteModal = ({ isOpen, onClose, onDelete }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="delete-modal-content" data-testid="delete-modal">
        Do you want to delete this officer?
        <button 
          className="delete-modal-delete-button" 
          onClick={onDelete}
          data-testid="confirm-delete-button"
        >
          Delete
        </button>
      </div>
    </Modal>
  );
};

export default DeleteModal;
